/* Auth module */
export const RESET_AUTH = "resetAuth";
export const PURGE_AUTH = "purgeAuth";
export const SET_TOKEN = "setToken";
export const SET_TOKEN_DATA = "setTokenData";
export const SET_USER_DATA = "setUserData";
export const SET_BEARER = "setBearer";
export const ERROR_AUTH = "errorAuthen";
export const SET_INFO_RELATION = "setInfoRelation";

/* Toggle module */
export const SET_CONFIRM_MODAL = "setConfirmModal";
export const START_LOADING = "startLoading";
export const END_LOADING = "endLoading";
export const SET_TAB = "setTab";

/* Input Pad module */
export const SET_CURRENT_INPUT_PAD = "setCurrentInputPad";
export const ON_INPUT_PAD_BLUR = "onInputPadBlur";
export const SET_INPUT_PAD_LENGTH = "setInputPadLength";

/* Search golf course */
export const LIST_AREA = "listArea";
export const SET_COURSE_DETAIL = "setCourseDetail";
export const SET_COURSE_REVIEW_TOTAL = "setCourseReviewTotal";

/* post */
export const SET_LANGUAGE_VLOG = "setDefaultLanguageVlog";
export const SET_LIST_LANGUAGE = "setListLanguageVlog";

/* interview */
export const SET_CURRENT_INTERVIEW = "setCurrentInterview";
